module.exports = __webpack_public_path__ + "static/media/8_api.0f336b3a.svg";